export const contactListsKeys = {
	all: ['contactLists'],
	list: () => ['contactLists', 'list'],
	detail: (listId) => ['contactLists', 'detail', listId],
	contacts: (listId, params) => ['contactLists', 'contacts', listId, params],
	contactsByListIds: (listIds) => ['contactLists', 'contactsByListIds', listIds],
	companies: (listId, params) => ['contactLists', 'companies', listId, params],
	companiesByListIds: (listIds) => ['contactLists', 'companiesByListIds', listIds],
	campaignRecipients: (campaignId) => ['contactLists', 'campaignRecipients', campaignId],
	search: (q, listIds) => ['contactLists', 'search', q, listIds ?? null],
};

export const contactListsMutationKeys = {
	create: ['contactLists', 'create'],
	update: ['contactLists', 'update'],
	delete: ['contactLists', 'delete'],
	addContacts: ['contactLists', 'addContacts'],
	removeContact: ['contactLists', 'removeContact'],
	removeCompany: ['contactLists', 'removeCompany'],
	recipientPosition: ['contactLists', 'recipientPosition'],
};

export const contactBlacklistKeys = {
	all: ['contactBlacklist'],
	lists: () => ['contactBlacklist', 'list'],
	list: (params) => ['contactBlacklist', 'list', params],
};

export const contactBlacklistMutationKeys = {
	create: ['contactBlacklist', 'create'],
	delete: ['contactBlacklist', 'delete'],
	bulkDelete: ['contactBlacklist', 'bulkDelete'],
};
